import {yupResolver} from '@hookform/resolvers/yup';
import * as yup from 'yup';
import {useMutation} from '@tanstack/react-query';
import {Button} from '@/shadcn_components/ui/button';
import Spinner from '@/components/basic/Spinner';
import {FormProvider, useForm} from 'react-hook-form';
import {useList} from '@refinedev/core';
import SelectMultipleInput from '@/components/refinedev/SelectMultipleInput';
import {useApiService} from '@/lib/ApiService';
import {defaultMutationOptions} from '../_utils';
import {useEffect} from 'react';

const changePasswordResolver = yupResolver(yup.object().shape({}).required());

type ChangeRoleButtonProps = {
  //   resource: string; //resource like parents, staffs, students, ...
  //   id: BaseID; //id of the userable model
  user: any;
};

export const ChangeRoleButton = (props: ChangeRoleButtonProps) => {
  const {user} = props;
  //   const dialogState = useDialogState();

  const useFormResults = useForm({
    resolver: changePasswordResolver,
  });

  // update form value if user changed
  useEffect(() => {
    if (user?.roles) useFormResults.reset({roles: user.roles});
  }, [user]);

  const apiService = useApiService();

  const mutation = useMutation<any, any, any>({
    ...defaultMutationOptions,
    mutationFn: async payload => {
      const roles = payload.roles;
      const results = await apiService.users.assignRoles(
        user.id,
        roles.map(item => item.id),
      );
      useFormResults.reset(payload); //reset dirty
      return results;
    },
  });

  const listRoleResults = useList({
    resource: 'roles',
    pagination: {pageSize: 9999},
    queryOptions: {refetchOnWindowFocus: false},
  });
  const listRoles = listRoleResults.data?.data || [];

  async function assignRoles(data) {
    try {
      await mutation.mutateAsync(data);
    } catch (err) {}
  }

  return (
    <>
      <FormProvider {...useFormResults}>
        <form onSubmit={useFormResults.handleSubmit(assignRoles)}>
          {/* <DialogHeader>Phân quyền</DialogHeader> */}
          <div className="flex flex-col gap-y-4">
            <div className="max-w-xl flex flex-col gap-y-4">
              <SelectMultipleInput
                source="roles"
                choices={listRoles}
                optionText="name"
                label="Phân quyền"
                placeHolder="Chọn"
              />
            </div>
            <div>
              {useFormResults.formState.isDirty && (
                <Button                  
                  color="blue"
                  type="submit"
                  // loading={mutation.isLoading}
                  disabled={mutation.isLoading}>
                  {mutation.isLoading && <Spinner />}
                  Lưu
                </Button>
              )}{' '}
            </div>
          </div>
        </form>
      </FormProvider>
    </>
  );
};
